import styled from 'styled-components';
import { Minus } from '@styled-icons/entypo/Minus';
import { Plus } from '@styled-icons/entypo/Plus';

const QuantityPicker = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  border-radius: 5px;
  width: ${props => props.$small ? '5em' : '9em'};
  height: ${props => props.$small ? '1.5em' : '2.5em'};
  user-select: none;
`;

const Change = styled.div`
  border: 1px solid rgba(0, 0, 0, .125);
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  width: 33%;
  height: 100%;
  color: #999;
  cursor: pointer;

  svg {
    height: 1.5em;
    width: 1.5em;
    color: ${props => props.theme.colors.typography.primary};
  }

  &:hover {
    color: #666;
  }

  &:first-child {
    border-radius: .25em 0 0 .25em;
  }

  &:last-child {
    border-radius: 0 .25em .25em 0;
  }
`;

const Quantity = styled.div`
    cursor: default;
    border-top: 1px solid rgba(0, 0, 0, .125);;
    border-bottom: 1px solid rgba(0, 0, 0, .125);;
    display: flex;
    font-size: ${props => props.$small ? '1em' : '1.5em'};
    align-items: center;
    justify-content: center;
    width: 33%;
    height: 100%;
`;

const IncrementDecrement = ({ onDecrement, onIncrement, value, small }) => {
  return (<QuantityPicker $small={small}>
    <Change className="decrement" onClick={onDecrement}>
      <Minus />
    </Change>
    <Quantity className="quantity" $small={small}>
      {value}
    </Quantity>
    <Change className="increment" onClick={onIncrement}>
      <Plus />
    </Change>
  </QuantityPicker>)
};

// export default observer(IncrementDecrement);
export default IncrementDecrement;
